<template>
  <div class="tabs">
    <div class="tabs__menu">
      <div class="grid-row grid-row_md">
        <div class="grid-col grid-col_same">
          <div
            class="tabs__button btn w-100 fs-18"
            :class="{ 'is-active': activeTab === 1 }"
            @click="activeTab = 1"
          >
            <span class="tabs__name">Описание</span>
          </div>
        </div>

        <div class="grid-col grid-col_same">
          <div
            class="tabs__button btn w-100 fs-18 js-review-click"
            :class="{ 'is-active': activeTab === 2 }"
            @click="activeTab = 2"
          >
            <span class="tabs__name">Отзывы&nbsp;</span>
            <span class="color-gray">{{ getReviewsCount }}</span>
          </div>
        </div>

        <div class="grid-col grid-col_same">
          <div
            class="tabs__button btn w-100 fs-18"
            :class="{ 'is-active': activeTab === 3 }"
            @click="activeTab = 3"
          >
            <span class="tabs__name">Вопросы&nbsp;</span>
            <span class="color-gray">{{ getQuestionsCount }}</span>
          </div>
        </div>

        <div class="grid-col grid-col_same" v-if="canReserve">
          <div
            class="tabs__button btn w-100 fs-18"
            :class="{ 'is-active': activeTab === 4 }"
            @click="activeTab = 4"
          >
            <span class="tabs__name">Наличие</span>
          </div>
        </div>

        <div v-if="getDocuments?.length" class="grid-col grid-col_same">
          <div
            class="tabs__button btn w-100 fs-18"
            :class="{ 'is-active': activeTab === 5 }"
            @click="activeTab = 5"
          >
            <span class="tabs__name">Документы</span>
          </div>
        </div>
      </div>
    </div>

    <div v-show="activeTab === 1">
      <RichContentBlock />
      <div class="pt-16" v-if="!isRichContent">
        <div class="fw-medium fs-20 mt-8">Характеристики</div>
        <ProductCharApp />
      </div>

      <div class="pt-40" v-if="!isRichContent">
        <div class="fw-medium fs-20 mb-16">Описание</div>
        <ProductDetailsApp />
      </div>

      <div v-if="isRichContent">
        <DropdownAdd text="Описание">
          <template v-slot:content>
            <ProductDetailsApp />
          </template>
        </DropdownAdd>

        <DropdownAdd text="Характеристики">
          <template v-slot:content>
            <ProductCharApp />
          </template>
        </DropdownAdd>
      </div>
    </div>

    <div v-if="activeTab === 2" class="mt-24">
      <!-- <Rating
        :ratingCount="getAverageRating"
        :show-number="true"
        ratingTotalString=" / 5"
        iconClass="rating__button_lg"
        textClass="fs-20 fw-medium ml-20 fs-sm-14 ml-sm-8"
      /> -->

      <!-- Нет отзывов -->
      <div v-if="getReviewsCount === 0">
        На этот товар пока нет отзывов — ваш может стать первым
        <div class="mt-8 color-gray">
          Расскажите о ваших впечатлениях о покупке
        </div>

        <div class="grid-row d-flex_sm-wrap grid-row_md mt-24" v-if="isAuth">
          <div class="grid-col grid-col_sm-100">
            <PopupLeaveReview />
          </div>
        </div>
      </div>

      <!-- Есть отзывы -->
      <SliderReviews v-if="getReviewsCount > 0" />
      <!-- /Есть отзывы -->
    </div>

    <div v-show="activeTab === 3" class="mt-24">
      <!-- Нет вопросов -->
      <div v-if="getQuestionsCount === 0">
        Об этом товаре пока нет вопросов — задайте его сейчас, и специалист
        ответит вам в ближайшее время

        <div class="grid-row d-flex_sm-wrap grid-row_md mt-24">
          <div class="grid-col grid-col_sm-100">
            <PopupLeaveQuestion />
          </div>
        </div>
      </div>

      <!-- Есть вопросы -->
      <SliderQuestions v-if="getQuestionsCount > 0" />
    </div>

    <div v-show="activeTab === 4" class="mt-24">
      <AvailabilityMain :active="activeTab === 4" />
    </div>

    <div v-show="activeTab === 5" class="mt-24">
      <template v-for="(item, key) in getDocuments" :key="key">
        <DocLink :text="item.name" :link="item.path" />
      </template>
    </div>
  </div>
  <PopupLeaveReviewMessage />
</template>

<script>
// import Rating from "../Rating/Rating.vue";
import SliderReviews from "../Sliders/SliderReviews.vue";
import SliderQuestions from "../Sliders/SliderQuestions.vue";
import PopupLeaveReview from "../Popups/PopupLeaveReview.vue";
import PopupLeaveReviewMessage from "../Popups/PopupLeaveReviewMessage.vue";
import { useReviewsStore } from "@/pages/product_card/stores/store_reviews";
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";

import ProductCharApp from "../CharacteristicBlock/CharacteristicBlock";
import ProductDetailsApp from "../DescriptionBlock/DescriptionBlock";
import DocLink from "../DocLink/DocLink.vue";
import PopupLeaveQuestion from "../Popups/PopupLeaveQuestion.vue";
import AvailabilityMain from "@/pages/product_card/components/Availability/AvailabilityMain.vue";
import RichContentBlock from "@/pages/product_card/components/RichContentBlock/RichContentBlock.vue";
import DropdownAdd from "@/pages/product_card/components/Dropdown/DropdownAdd.vue";

export default {
  name: "Tabs",
  components: {
    RichContentBlock,
    AvailabilityMain,
    // Rating,
    SliderReviews,
    SliderQuestions,
    PopupLeaveReview,
    PopupLeaveReviewMessage,
    ProductCharApp,
    ProductDetailsApp,
    DocLink,
    PopupLeaveQuestion,
    DropdownAdd,
  },
  data() {
    return {
      activeTab: 1,
      isAuth: window.isAuth,
    };
  },
  computed: {
    ...mapState(useReviewsStore, [
      "getQuestions",
      "getReviews",
      "getQuestionsCount",
      "getReviewsCount",
      "getQuestionsForSlider",
      "getAverageRating",
      "getDocuments",
    ]),
    ...mapState(useProductStore, [
      "getDocuments",
      "canReserve",
      "isRichContent",
    ]),
  },
  watch: {
    canReserve(newVal) {
      if (!newVal && this.activeTab === 4) {
        this.activeTab = 1;
      }
    },
  },
};
</script>

<style lang="scss">
@import "./tabs.scss";
</style>
